import styled from 'styled-components'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const mobileQuery = createResponsiveBreakpointQuery('mobileDown', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.mobileDown
})

const smallDesktopQuery = createResponsiveBreakpointQuery('smallDesktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.smallDesktopUp
})

export const MoreActionIcon = styled.div`
  display: flex;
  width: ${({ $isGrid }) => ($isGrid ? '18px' : '30px')};
  height: ${({ $isGrid }) => ($isGrid ? '18px' : '30px')};
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  justify-content: center;
  transition: background-color 0.25s;
  border-radius: 50%;
  background-color: transparent;

  svg {
    width: 18px;
    height: 18px;
  }

  @media ${smallDesktopQuery} {
    &:hover {
      color: #aaaaaa;
      background-color: ${({ theme }) => `${theme.colors.neutralW30}`};
    }
  }

  @media ${mobileQuery} {
    width: ${({ $isGrid }) => ($isGrid ? '12px' : '30px')};
    height: ${({ $isGrid }) => ($isGrid ? '12px' : '30px')};

    svg {
      width: ${({ $isGrid }) => ($isGrid ? '12px' : '18px')};
      height: ${({ $isGrid }) => ($isGrid ? '12px' : '18px')};
    }
  }
`
